export const codeArr = [

    {
      code: `int age = 25;
int temperature = -10;
dataType: Integer (int)`
    },

    {
      code: `float pi = 3.14;
double salary = 2500.50;
dataType: Floating-point (float or double)`
    },

    {
      code: `char grade = 'A';
char symbol = '$' 
dataType: Character (char)`
    },

    {
      code: `int isStudent = 1; // true
int isAdmin = 0; // false
dataType: Boolean (bool)`
    },

    {
      code: `char name[] = "John Doe";
char message[20] = "Hello, World!";
dataType: String`
    },

    {
      code: `int numbers[5] = {1, 2, 3, 4, 5};
char vowels[] = {'a', 'e', 'i', 'o', 'u'};
dataType: Array`
    },

  ];
  